import { createSlice } from "@reduxjs/toolkit";

const cleanState = {
  tabPosition: '',
};

const uiSlice = createSlice({
  name: "ui",
  initialState: cleanState,
  reducers: {
    setTabPosition(state, action) {
      state.tabPosition = action.payload;
    },
  },
});

export const { setTabPosition } = uiSlice.actions;

export default uiSlice.reducer;
